import { render, staticRenderFns } from "./newWork.vue?vue&type=template&id=01e53850&"
import script from "./newWork.vue?vue&type=script&lang=js&"
export * from "./newWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports